import { useState } from 'react';
import { getContainer } from '@framework/di/getContainer';
import { getErrorMessage } from '@framework/message/Mapper/getMessage';
import { AlertManager } from '@dealroadshow/uikit-alert';
import LandingRepository from '@/dataroom/infrastructure/repository/LandingRepository';

const useSizes = () => {
  const container = getContainer();
  const [isFetching, setIsFetching] = useState<boolean>(false);
  const [collection, setCollection] = useState<{
    value: string,
    label: string,
  }[]>([]);

  const getSizes = async () => {
    setIsFetching(true);

    try {
      const landingRepository = container.get<LandingRepository>(LandingRepository);
      const response = await landingRepository.getSizes();

      const collection = response.map(({ id, display_name, pages }) => ({
        value: id.toString(),
        label: `${ display_name } (~ ${ pages.toLocaleString('en-US') } pages)`,
      }));

      setCollection(collection);
    } catch (error) {
      AlertManager.error(getErrorMessage(error));
    } finally {
      setIsFetching(false);
    }
  };

  return {
    isFetching,
    collection,
    getSizes,
  };
};

export default useSizes;
